import { BrokerRatingDetail } from "../BrokerRatingDetail";
import { CarrierCancellationsDetail } from "../CarrierCancellationsDetail";
import { CarrierPayDetail } from "../CarrierPayDetail";
import { CheckCallComplianceDetail } from "../CheckCallComplianceDetail";
import { ClaimsDetail } from "../ClaimsDetail";
import { DateRangeMoveWeightDetail } from "../DateRangeMoveWeightDetail";
import { EDIAccuracyDetail } from "../EDIAccuracyDetail";
import { EDIResponseDetail } from "../EDIResponseDetail";
import { NumberOfMovesDetail } from "../NumberOfMovesDetail";
import { OnTimeDetail } from "../OnTimeDetail";
import { PaymentMethodDetail } from "../PaymentMethodDetail";
import { DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCarrierScorecardProfileDetail extends Layout {
    layoutBrokerRatingDetail: BrokerRatingDetail;
    layoutCarrierCancellationsDetail: CarrierCancellationsDetail;
    layoutCarrierPayDetail: CarrierPayDetail;
    layoutCheckCallComplianceDetail: CheckCallComplianceDetail;
    layoutClaimsDetail: ClaimsDetail;
    layoutDateRangeMoveWeightDetail: DateRangeMoveWeightDetail;
    layoutEDIAccuracyDetail: EDIAccuracyDetail;
    layoutEDIResponseDetail: EDIResponseDetail;
    layoutNumberOfMovesDetail: NumberOfMovesDetail;
    layoutOnTimeDetail: OnTimeDetail;
    layoutPaymentMethodDetail: PaymentMethodDetail;
    panelMetricFields: Panel;
    sourceCarrierScorecardDetail: DataSource;
    textboxDescription: Textbox;
    textboxPerfMetric: Textbox;
}
